import {
  ADD_ATTACHMENTS_FAILURE,
  ADD_ATTACHMENTS_REQUEST,
  ADD_ATTACHMENTS_SUCCESS,
  ADD_TICKET_COMMENTS_FAILURE,
  ADD_TICKET_COMMENTS_REQUEST,
  ADD_TICKET_COMMENTS_SUCCESS,
  CREATE_REPORT_TICKET_FAILURE,
  CREATE_REPORT_TICKET_REQUEST,
  CREATE_REPORT_TICKET_SUCCESS,
  GET_CLIENT_TICKETS_STATUS_FAILURE,
  GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_FAILURE,
  GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_REQUEST,
  GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_SUCCESS,
  GET_CLIENT_TICKETS_STATUS_REQUEST,
  GET_CLIENT_TICKETS_STATUS_SUCCESS,
  GET_COMPLETED_TICKETS_FAILURE,
  GET_COMPLETED_TICKETS_REQUEST,
  GET_COMPLETED_TICKETS_SUCCESS,
  GET_REPORTED_TICKETS_FAILURE,
  GET_REPORTED_TICKETS_REQUEST,
  GET_REPORTED_TICKETS_SUCCESS,
  GET_REQUESTTYPES_FAILURE,
  GET_REQUESTTYPES_REQUEST,
  GET_REQUESTTYPES_SUCCESS,
  GET_TICKET_COMMENTS_FAILURE,
  GET_TICKET_COMMENTS_REQUEST,
  GET_TICKET_COMMENTS_SUCCESS,
  GET_TICKET_STATUS_FAILURE,
  GET_TICKET_STATUS_REQUEST,
  GET_TICKET_STATUS_SUCCESS,
  GET_USERS_BY_CLIENT_FAILURE,
  GET_USERS_BY_CLIENT_REQUEST,
  GET_USERS_BY_CLIENT_SUCCESS,
  RE_OPEN_TICKET_FAILURE,
  RE_OPEN_TICKET_REQUEST,
  RE_OPEN_TICKET_SUCCESS,
  TICKET_HOMEPAGE_FAILURE,
  TICKET_HOMEPAGE_REQUEST,
  TICKET_HOMEPAGE_SUCCESS,
} from "./clientTicketTypes";

const initialState = {
  loading: false,
  tickets: {},
  error: "",
};

const reportedTicketsReducerForClient = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORTED_TICKETS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_REPORTED_TICKETS_SUCCESS:
      return {
        loading: false,
        tickets: action.payload,
        error: "",
      };
    case GET_REPORTED_TICKETS_FAILURE:
      return {
        loading: false,
        tickets: {},
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForCreateIssue = {
  loading: false,
  issue: {},
  error: "",
};

const createIssueReducerForClient = (
  state = initialStateForCreateIssue,
  action
) => {
  switch (action.type) {
    case CREATE_REPORT_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_REPORT_TICKET_SUCCESS:
      return {
        loading: false,
        issue: action.payload,
        error: "",
      };
    case CREATE_REPORT_TICKET_FAILURE:
      return {
        loading: false,
        issue: {},
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForRequestTypes = {
  loading: false,
  requestTypes: [],
  error: "",
};

const requestTypesReducerForClient = (
  state = initialStateForRequestTypes,
  action
) => {
  switch (action.type) {
    case GET_REQUESTTYPES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_REQUESTTYPES_SUCCESS:
      return {
        loading: false,
        requestTypes: action.payload,
        error: "",
      };
    case GET_REQUESTTYPES_FAILURE:
      return {
        loading: false,
        requestTypes: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateAddAttachments = {
  loading: false,
  attachments: {},
  error: "",
};

const addAttachmentsReducerForClient = (
  state = initialStateAddAttachments,
  action
) => {
  switch (action.type) {
    case ADD_ATTACHMENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_ATTACHMENTS_SUCCESS:
      return {
        loading: false,
        attachments: action.payload,
        error: "",
      };
    case ADD_ATTACHMENTS_FAILURE:
      return {
        loading: false,
        attachments: {},
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForIssueStatus = {
  loading: false,
  issueStatus: {},
  error: "",
};

const issueStatusReducerForClient = (
  state = initialStateForIssueStatus,
  action
) => {
  switch (action.type) {
    case GET_TICKET_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TICKET_STATUS_SUCCESS:
      return {
        loading: false,
        issueStatus: action.payload,
        error: "",
      };
    case GET_TICKET_STATUS_FAILURE:
      return {
        loading: false,
        issueStatus: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForIssueComments = {
  loading: false,
  issueComments: [],
  error: "",
};

const issueCommentsReducerForClient = (
  state = initialStateForIssueComments,
  action
) => {
  switch (action.type) {
    case GET_TICKET_COMMENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TICKET_COMMENTS_SUCCESS:
      return {
        loading: false,
        issueComments: action.payload,
        error: "",
      };
    case GET_TICKET_COMMENTS_FAILURE:
      return {
        loading: false,
        issueComments: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForUsers = {
  loading: false,
  clients: [],
  error: "",
};

const UsersByclientReducer = (state = initialStateForUsers, action) => {
  switch (action.type) {
    case GET_USERS_BY_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USERS_BY_CLIENT_SUCCESS:
      return {
        loading: false,
        clients: action.payload,
        error: "",
      };
    case GET_USERS_BY_CLIENT_FAILURE:
      return {
        loading: false,
        clients: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForAddComment = {
  loading: false,
  issueComment: {},
  error: "",
};

const addIssueCommentReducerForClient = (
  state = initialStateForAddComment,
  action
) => {
  switch (action.type) {
    case ADD_TICKET_COMMENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_TICKET_COMMENTS_SUCCESS:
      return {
        loading: false,
        issueComment: action.payload,
        error: "",
      };
    case ADD_TICKET_COMMENTS_FAILURE:
      return {
        loading: false,
        issueComment: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForReopenIssue = {
  loading: false,
  issue: {},
  error: "",
};

const reopenIssueReducerForClient = (
  state = initialStateForReopenIssue,
  action
) => {
  switch (action.type) {
    case RE_OPEN_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case RE_OPEN_TICKET_SUCCESS:
      return {
        loading: false,
        issue: action.payload,
        error: "",
      };
    case RE_OPEN_TICKET_FAILURE:
      return {
        loading: false,
        issue: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForClient = {
  loading: false,
  clientTickets: {},
  error: "",
};

const homePageForClientTickets = (state = initialStateForClient, action) => {
  switch (action.type) {
    case TICKET_HOMEPAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TICKET_HOMEPAGE_SUCCESS:
      return {
        loading: false,
        clientTickets: action.payload,
        error: "",
      };
    case TICKET_HOMEPAGE_FAILURE:
      return {
        loading: false,
        clientTickets: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForCompletedTickets = {
  loading: false,
  compTickets: {},
  error: "",
};

const getCompletedTicketsForClientReducer = (
  state = initialStateForCompletedTickets,
  action
) => {
  switch (action.type) {
    case GET_COMPLETED_TICKETS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPLETED_TICKETS_SUCCESS:
      return {
        loading: false,
        compTickets: action.payload,
        error: "",
      };
    case GET_COMPLETED_TICKETS_FAILURE:
      return {
        loading: false,
        compTickets: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForStatus = {
  loading: false,
  tickets: [],
  error: "",
};

const getTicketsForCompletedReducer = (
  state = initialStateForStatus,
  action
) => {
  switch (action.type) {
    case GET_CLIENT_TICKETS_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CLIENT_TICKETS_STATUS_SUCCESS:
      return {
        loading: false,
        tickets: action.payload,
        error: "",
      };
    case GET_CLIENT_TICKETS_STATUS_FAILURE:
      return {
        loading: false,
        tickets: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForActive = {
  loading: false,
  ticketsActive: [],
  error: "",
};

const getTicketsStatusForActiveReducer = (
  state = initialStateForActive,
  action
) => {
  switch (action.type) {
    case GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_SUCCESS:
      return {
        loading: false,
        ticketsActive: action.payload,
        error: "",
      };
    case GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_FAILURE:
      return {
        loading: false,
        ticketsActive: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  reportedTicketsReducerForClient,
  createIssueReducerForClient,
  requestTypesReducerForClient,
  homePageForClientTickets,
  issueStatusReducerForClient,
  issueCommentsReducerForClient,
  addIssueCommentReducerForClient,
  reopenIssueReducerForClient,
  addAttachmentsReducerForClient,
  UsersByclientReducer,
  getCompletedTicketsForClientReducer,
  getTicketsForCompletedReducer,
  getTicketsStatusForActiveReducer,
};
